import { Section } from '../layout/Section'

/**
 * "Cosa comprende": the service's deliverables as a two-column checklist.
 * Each row is a `[data-reveal]` target (Task 12 fades them in on scroll).
 */
export function IncludesList({ title, items }: { title: string; items: readonly string[] }) {
  return (
    <Section>
      <h2 className="vc2-display text-3xl md:text-4xl">{title}</h2>
      <ul className="mt-8 grid gap-4 md:grid-cols-2">
        {items.map((item) => (
          <li key={item} data-reveal className="flex gap-4 border-t border-vc2-hairline pt-4">
            <svg
              aria-hidden="true"
              viewBox="0 0 24 24"
              className="mt-0.5 h-5 w-5 shrink-0 text-vc2-accent"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>
            <span className="text-vc2-ink-soft">{item}</span>
          </li>
        ))}
      </ul>
    </Section>
  )
}
